import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule, Router } from '@angular/router';
import { AccountSettingsComponent } from 'src/app/account-settings/account-settings/account-settings.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Logger } from 'src/services/core/logger/logger.service';
import { BaseNameAvatarComponent } from '../base-name-avatar/base-name-avatar.component';
import { PersistenceService } from 'src/services/core/persistence/persistence.service';
import { Notification } from 'src/services/classes/models/notification.interface';
import { DateagoPipe } from 'src/services/pipes/dateago/dateago.pipe';
import { NotifsService } from 'src/services/data/notifications/notifs.service';
import { Response } from 'src/services/classes/models/response.interface';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';

const log = new Logger('Header');
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    NgClass,
    MatMenuModule,
    RouterModule,
    BaseNameAvatarComponent,
    DateagoPipe,
  ],
  entryComponents: [AccountSettingsComponent],
})
export class HeaderComponent implements OnInit {
  modalService = inject(NgbModal);
  isOnline = false;
  exact = { exact: true };
  notifications: Notification[] = [];
  notificationsFetched = false;
  unreadCount: number = 0;

  private audio: HTMLAudioElement;

  constructor(
    private credentialsService: CredentialsService,
    private router: Router,
    private persistenceService: PersistenceService,
    private notifService: NotifsService,
    private notifyService: NotificationsService
  ) {
    this.audio = new Audio();
    this.audio.src = '/assets/sounds/notification.mp3';
  }

  ngOnInit(): void {
    this.getNotifications();
  }

  credentials = () => this.credentialsService.credentials;

  // change this to the modal call
  editProfile = () => {
    const modalRef = this.modalService.open(AccountSettingsComponent, {
      size: 'lg',
      animation: true,
      centered: true,
    });

    modalRef.result
      .then((result: any) => {
        log.debug('res: ', result);
      })
      .catch((error: any) => log.debug('error from action modal: ', error));
  };

  getNotifications() {
    const notificationItems =
      this.persistenceService.get('notifications') || [];
    if (notificationItems && notificationItems.length > 0) {
      this.notifications = notificationItems;
      setTimeout(() => {
        this.unreadCount =
          this.notifications &&
          this.notifications.filter(
            (notif: Notification) => notif.isRead === false
          )?.length;
      }, 10);
    } else if (this.notificationsFetched === false) {
      this.getAllNotifications();
    }
  }

  logout = () => {
    this.router.navigateByUrl('/auth');
    this.persistenceService.delete('notifications');
    this.persistenceService.delete('current-restaurant');
    this.credentialsService.setCredentials();
  };

  markNotificationAsRead(
    countToRead: string,
    item: Notification | null = null
  ) {
    // Update state when a notification or all notifications is marked as read
    // Mark all notifications as read!
    this.triggerMarkNotification(countToRead, item);
  }

  triggerMarkNotification(
    countToRead: string,
    item: Notification | null = null
  ) {
    const markNotif$ =
      countToRead === 'all'
        ? this.notifService.markAllNotificationsAsRead()
        : this.notifService.markNotificationAsRead(Number(item?.id));
    markNotif$.subscribe({
      next: (res: Response) => {
        if (res.status.toLowerCase() === 'success') {
          this.getAllNotifications();
          res?.message
            ? this.notifyService.publishMessages(res.message, 'success', 1)
            : this.notifyService.publishMessages(
                'Notification marked as read',
                'success',
                1
              );
        } else {
          res?.message
            ? this.notifyService.publishMessages(res.message, 'danger', 1)
            : this.notifyService.publishMessages(
                'An error occurred',
                'danger',
                1
              );
        }
      },
      error: (err) => log.error('err: ', err),
    });
  }

  getAllNotifications() {
    const notifications$ = this.notifService.getAllNotifications();
    notifications$.subscribe({
      next: (res: Response) => {
        if (res.status.toLowerCase() === 'success') {
          if (res.data) {
            const currentNotifs =
              this.persistenceService.get('notifications') || [];
            // Play sound if there are new notifications
            if (res.data.length > currentNotifs.length) {
              this.audio.play().catch((error) => {
                console.error('Error playing notification sound:', error);
              });
            }
            this.persistenceService.set('notifications', res.data);
            setTimeout(() => this.getNotifications());
          }
        } else {
          res?.message
            ? this.notifyService.publishMessages(res.message, 'danger', 1)
            : this.notifyService.publishMessages(
                'An error occurred',
                'danger',
                1
              );
        }
      },
      error: (error) => log.debug('error: ', error),
    });
  }
}
